export const UseOfProceeds = {
  AcuteCare: 'Acute Care',
  Agriculture: 'Agriculture',
  Airlines: 'Airlines',
  Airport: 'Airport',
  AssistedLiving: 'Assisted Living',
  Bridges: 'Bridges',
  Building: 'Building',
  CharterSchool: 'Charter School',
  CivicConventionCenters: 'Civic/Convention Centers',
  CombinedUtilities: 'Combined Utilities',
  CorrectionFacilities: 'Correction Facilities',
  CorrectionFacilitiesCourts: 'Correction Facilities/Courts',
  Courts: 'Courts',
  EconomicDevelopment: 'Economic Development',
  Education: 'Education',
  Electricity: 'Electricity',
  ElectricPublicPower: 'Electric & Public Power',
  EnvironmentProtection: 'Environment Protection',
  Equipment: 'Equipment',
  FireStationEquipment: 'Fire Station & Equipment',
  FloodControlStormDrain: 'Flood Control/Storm Drain',
  Gas: 'Gas',
  GeneralPurpose: 'General Purpose',
  GovernmentPublicBuildings: 'Government/Public Buildings',
  HealthcareSystem: 'Healthcare System',
  HigherEducation: 'Higher Education',
  Highways: 'Highways',
  HospitalEquipmentLoans: 'Hospital Equipment Loans',
  Hospitals: 'Hospitals',
  Housing: 'Housing',
  IndustrialDevelopment: 'Industrial Development',
  Irrigation: 'Irrigation',
  LandPreservation: 'Land Preservation',
  Libraries: 'Libraries',
  LibrariesMuseums: 'Libraries/Museums',
  MallsShoppingCenters: 'Malls/Shopping Centers',
  MassRapidTransport: 'Mass/Rapid Transport',
  MultiFamilyHousing: 'Multi-Family Housing',
  Museums: 'Museums',
  NurseHomes: 'Nurse Homes',
  OfficeBuilding: 'Office Building',
  OtherEducation: 'Other Education',
  OtherHealthcare: 'Other Healthcare',
  OtherHousing: 'Other Housing',
  OtherPublicService: 'Other Public Service',
  OtherTransportation: 'Other Transportation',
  OtherUtilities: 'Other Utilities',
  ParkingFacilities: 'Parking Facilities',
  Parks: 'Parks',
  ParksZoosBeaches: 'Parks/Zoos/Beaches',
  PensionFundingRetirement: 'Pension Funding/Retirement',
  PoliceStationEquipment: 'Police Station/Equipment',
  PollutionControl: 'Pollution Control',
  PrimarySecondaryEducation: 'Primary & Secondary Education',
  Psychiatric: 'Psychiatric',
  PublicImprovements: 'Public Improvements',
  PublicPower: 'Public Power',
  PublicSafety: 'Public Safety',
  Rail: 'Rail',
  Recreation: 'Recreation',
  RedevelopmentLdClearance: 'Redevelopment/Ld Clearance',
  Rehabilitation: 'Rehabilitation',
  ResourceRecovery: 'Resource Recovery',
  RetirementCenters: 'Retirement Centers',
  RoadHighway: 'Road/Highway',
  Roads: 'Roads',
  Sanitation: 'Sanitation',
  SeaportsMarineTerminals: 'Seaports/Marine Terminals',
  SeniorHousing: 'Senior Housing',
  Sewer: 'Sewer',
  SingleAndMultiFamilyHousing: 'Single and Multi-Family Housing',
  SingleFamilyHousing: 'Single Family Housing',
  SolidWaste: 'Solid Waste',
  SolidWasteResourceRecovery: 'Solid Waste/Resource Recovery',
  StadiumsSportsComplex: 'Stadiums/Sports Complex',
  StudentLoans: 'Student Loans',
  SwimmingPool: 'Swimming Pool',
  TeleCommunication: 'TeleCommunication',
  Theaters: 'Theaters',
  Tobacco: 'Tobacco',
  TollRoadsHighwaysStreets: 'Toll Roads/Highways/Streets',
  Transportation: 'Transportation',
  Tunnels: 'Tunnels',
  Turnpike: 'Turnpike',
  VariousPurpose: 'Various Purpose',
  Veterans: 'Veterans',
  Water: 'Water',
  WaterAndSewer: 'Water & Sewer',
  ZoosBeaches: 'Zoos/Beaches',
} as const

export type UseOfProceeds = (typeof UseOfProceeds)[keyof typeof UseOfProceeds]
